import { Injectable } from '@angular/core';
import { DialogService } from '@tylertech/forge-angular';
import { Constants } from "../../meeting-manager/lib/constants";
import { DialogComponent } from '../common/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CreatePdfService {
  popup: Window | undefined;
  
  constructor(public constants: Constants,
    private dialogService: DialogService) { }

  openNewTab() {
    const randomNumber = Math.random();
    return window.open('', 'Print' + randomNumber)!;
  }
  checkIsPopUpBlocked(popup: Window|null) {
    if (!popup || typeof(popup)==='undefined') {  
      this.dialogService.open(DialogComponent,
      {
        options: this.constants.setDialogOptions(false, this.constants.forgeDialog.dialogClass),
        data:{
          content: this.constants.messages.error.popupBlocked,
          ok: this.constants.forgeDialog.btnData.okBtnText
        }
      });
      return true;
    }
    return false;
  }
  openNewTabActionWithValidationCheck() {
    const createdNewTab = this.openNewTab();
    // check if popup is blocked by browser, assign value based on that condition
    this.popup = this.checkIsPopUpBlocked(createdNewTab) ? undefined : createdNewTab;
    // return popup to exit function if popup is nto created by browser
    return this.popup;
  }
  setupPdfPopupLocation(data: Blob) {
    if(this.popup) {
      const file = new Blob([data], { type: 'application/pdf' });
      this.popup.location.href = URL.createObjectURL(file);
    }
  }
}
